import { Object as FabricObject } from 'fabric/fabric-impl';
import { SportType } from 'modules/core/domain/enums/sport-type';
import { BoardTypeEnum } from 'modules/core/domain/interfaces/supabase/overlay/auxiliary-types';
import { Resolution } from 'modules/overlay-canvas/types';
import { MatchEventType } from 'shared/types/match-event';

/** Marker that tells our file apart from any other JSON. Never change it. */
export const BOARD_TEMPLATE_FILE_FORMAT = 'imgame.board-template';

/**
 * Bump on an incompatible change of the file shape. The parser rejects files from
 * a newer version instead of guessing, so already downloaded files keep working.
 */
export const BOARD_TEMPLATE_FILE_VERSION = 1;

export const BOARD_TEMPLATE_FILE_SUFFIX = '.imgame-board-template.json';

/** Fabric version stamped on boards created by the editor today (`overlay.ts`, start board). */
export const DEFAULT_BOARD_OBJECTS_VERSION = '5.3.0';

/** Column defaults of Supabase `boards` and `templates` — what the stand would write itself. */
export const DEFAULT_BOARD_TYPE: BoardTypeEnum = 'static';
/**
 * Seconds a board stays on screen when nothing else is set: a new board in the editor, a file without a
 * valid `duration`, a kit board. The Supabase column default is still 4 — the client always sends it.
 */
export const DEFAULT_BOARD_DURATION = 7;
export const DEFAULT_TEMPLATE_RESOLUTION: Resolution = { width: 1920, height: 1080 };

/**
 * The template itself. No `id`, `owner_id`, `access`, `visibility`, `alias`, likes,
 * views or dates: they belong to the source stand and owner and are set anew on import.
 */
export interface BoardTemplateFileTemplate {
  name: string;
  sportType: SportType;
  resolution: Resolution;
}

/** One board. No `id`, `template_id`, `alias`, `is_favorite`, `created_at`. */
export interface BoardTemplateFileBoard {
  name: string;
  version: string;
  type: BoardTypeEnum;
  events: MatchEventType[];
  /** Seconds the board stays on screen (`events` and `carousel` boards). */
  duration: number;
  order: number;
  objects: FabricObject[];
}

export interface BoardTemplateFile {
  format: typeof BOARD_TEMPLATE_FILE_FORMAT;
  formatVersion: number;
  exportedAt: string;
  source: { origin: string };
  template: BoardTemplateFileTemplate;
  boards: BoardTemplateFileBoard[];
}
